import { withPageAuthRequired } from "@common/middleware";
import cx from "classnames";
import { FC, useEffect } from "react";
import { useRouter } from "next/router";
import MxWidget from "@modules/mx/components/Widget";
import { MxWidgetType } from "@modules/mx/types";
import useStore from "@common/state";
import Link from "next/link";
import { Typography } from "@earned/core";
import { ClientRoutes } from "@common/constants";

const SpendingNavItem = ({
  title,
  view,
}: {
  title: string;
  view: "transactions" | "categories" | "trends" | "budgets";
}) => {
  const router = useRouter();
  const isActive = router.query?.view === view;
  return (
    <Link href={`${ClientRoutes.Spending}?view=${view}`}>
      <Typography
        variant="body"
        color={isActive ? "primary" : "secondary"}
        weight={isActive ? "medium" : "normal"}
      >
        <button
          className={cx("hover:text-green-1", isActive ? "tracking-tight" : "")}
        >
          {title}
        </button>
      </Typography>
    </Link>
  );
};

const SpendingPage: FC = () => {
  const router = useRouter();
  const view = router.query?.view as string;
  const setCurrentSpendingView = useStore(
    (state) => state.setCurrentSpendingView
  );
  useEffect(() => {
    if (!router.query.view) {
      router.replace(
        { query: { ...router.query, view: "transactions" } },
        undefined,
        { shallow: true }
      );
    }
    setCurrentSpendingView(view);
  }, [view, setCurrentSpendingView, router]);
  return (
    <div className="flex min-w-0 flex-1 flex-col">
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex flex-row flex-nowrap items-center justify-start space-x-6 overflow-x-auto px-4 py-6 md:px-10">
          <SpendingNavItem title="Transactions" view="transactions" />
          <SpendingNavItem title="Categories" view="categories" />
          <SpendingNavItem title="Trends" view="trends" />
          <SpendingNavItem title="Budgets" view="budgets" />
        </div>
        <div className="offset-mobile-bottom-padding-hack flex flex-1">
          {view === "transactions" && (
            <MxWidget widgetType={MxWidgetType.transactions_widget} />
          )}
          {view === "categories" && (
            <MxWidget widgetType={MxWidgetType.spending_widget} />
          )}
          {view === "trends" && (
            <MxWidget widgetType={MxWidgetType.trends_widget} />
          )}
          {view === "budgets" && (
            <MxWidget widgetType={MxWidgetType.budgets_widget} />
          )}
        </div>
      </div>
    </div>
  );
};

export default withPageAuthRequired(SpendingPage);
